import React from "react"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import { FaChevronLeft, FaChevronRight } from "react-icons/fa"
import clsx from "clsx"

import { Button } from "components"
import { isDirectionLtr } from "utils"
import classes from "./KcHeader.module.scss"

const KcHeader = () => {
  const [t, i18n] = useTranslation()

  const history = useHistory()

  const handleGoBack = () => {
    history.push("/kiosk-foods")
  }

  const isLtr =
    isDirectionLtr(i18n.language)

  return (
    <div className={classes["header"]}>
      <Button
        className={classes["button"]}
        onClick={handleGoBack}
      >
        {isLtr ? <FaChevronLeft size={18} /> : <FaChevronRight size={18} />}

        <span
          className={clsx(
            classes["text"],
            isLtr && classes["text-ltr"]
          )}
        >
          {t("بازگشت")}
        </span>
      </Button>

      <div className={classes["header-right"]}>
        <h1 className={classes["title"]}>
          {t("سفارش_شما")}
        </h1>

        <p className={classes["subtitle"]}>
          {t("سفارش_خود_را_چک_کنید_سپس_روش_پرداخت_خود_را_انتخاب_و_سفارش_را_پرداخت_کنید")}.
        </p>
      </div>
    </div>
  )
}

export default KcHeader